const parsePackageLabels = (pkg, i) => ({
  ...pkg,
  _id: pkg.newPackageNumber?.toString() || pkg.packageNumber?.toString() || i.toString(),
});

export { parsePackageLabels };
